import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import Image from 'UIKit/Image'
import Tab, { TabProps } from 'UIKit/Tab'
import Text from 'UIKit/Text'
import useGameTag from 'hooks/useGameTag'
import { Trans } from 'react-i18next'
import styled from 'styled-components'

export const StyledTabContainer = styled(Tab)<{ $active: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  min-width: 96px;

  ${Text} {
    text-align: center;
    transition: ${({ theme }) => theme.transitions.fast};
    color: ${({ theme, $active }) => ($active ? `${theme.colors.text} !important` : theme.colors.textSubtle)};
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    min-width: 120px;
  }

  &:hover,
  &:focus-visible {
    ${Text} {
      color: ${({ theme }) => theme.colors.text};
    }
  }
`

type GameTagTabProps = {
  tagCode: string
  selectedValue: string
  id?: string
}

const GameTagTab: React.FC<GameTagTabProps & TabProps & BoxProps> = ({ tagCode, selectedValue, id, ...props }) => {
  const tag = useGameTag(tagCode)
  return (
    tag && (
      <StyledTabContainer id={id} className="game-tag-item" $active={selectedValue === tag.value} {...props}>
        <Box width={['24px', '24px', '28px']} height={['24px', '24px', '28px']} zIndex="-1" className="image-container">
          <Image src={tag.img} alt={tag.content} height={64} width={64} />
        </Box>
        <Text bold fontSize="12px" mt={['4px', '4px', '8px']}>
          <Trans>{tag?.content}</Trans>
        </Text>
      </StyledTabContainer>
    )
  )
}

export default GameTagTab
